export default __webpack_public_path__ + "static/professional-network-b827eba6f035bf58ff854ebed20c127d.jpeg";